import { mdiMenu } from "@mdi/js";
import Icon from "../Icon";
import styles from "./BurgerMenu.module.css";

interface BurgerMenuProps {
  onClick?: () => void;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ onClick }) => {
  return (
    <div className={styles.BurgerMenu} onClick={onClick}>
      <Icon d={mdiMenu} size={24} />
    </div>
  );
};

export default BurgerMenu;
